import { Module } from "vuex";

import { PatientsApi } from "@/api/patients";
import { RootState } from "@/types";
import { Patient } from "@/types/users";

interface PatientState {
  patient: Patient;
}
interface ModuleContext {
  state: PatientState;
  rootState: any;
  rootGetters: any;
  commit: any;
}

export const patient: Module<PatientState, RootState> = {
  namespaced: true,
  state: {
    patient: {
      id: "",
      practitioner: {
        id: "",
        slots: [],
      },
    },
  },
  mutations: {
    setPatient(state, payload) {
      state.patient = payload;
    },
  },
  actions: {
    async getPatientProfile({ commit, rootGetters }: ModuleContext, payload?: string) {
      const { uid } = rootGetters;
      const payloadId = payload || uid;
      const profile = await PatientsApi.patientGetProfile(payloadId);
      commit("setPatient", profile);
    },
  },
  getters: {
    patient(state) {
      return state.patient;
    },
    patientsPractitioner(state) {
      return state.patient.practitioner;
    },
  },
};
